export { ElearningLeadHero } from "./hero";
export { ElearningLeadHighlights } from "./highlights";
export { ElearningLeadForm } from "./form";
export { IeltsPageTopSection } from "./ielts_page/top_section";
export { IeltsPageHighlightsSection } from "./ielts_page/heighlights_section";
export { IeltsPageFormSection } from "./ielts_page/form_section";
export { GrammaticalAccuracy } from "./grammatical_accuracy";
export { PrepareIeltsExam } from "./prepare_ielts_exam";
export { DailyIdiomsPhrases } from "./daily_idioms_phrases";
export { ImproveLexicalResource } from "./improve_lexical_resource";
export { AcademicWritingTask1 } from "./academic_writing_task1";
export { IELTSListeningStrategies } from "./listening_strategies";
export { CompleteIeltsTraining } from "./complete_IELTS_training";
